import React, { useState, useEffect, useRef } from "react"
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { useParams } from "react-router-dom";
import BotaoVoltar from "./common/botaoVoltar";
import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
import CloseIcon from '@mui/icons-material/Close';
import { URL_API } from '../config/urls'
import fetchWithToken from '../config/UseFetchWithToken';

export default function EditarSrf() {

	const [dados, setDados] = useState({});
	const [mostraMensagem, setMostrarMensagem] = useState(false)
	const [mensagem, setMensagem] = useState("")
	const txtCodigo = useRef(null);
	const txtNome = useRef(null);
	const txtObs = useRef(null);
	const txtEmail = useRef(null);
	let { id } = useParams();

	useEffect(() => {
		if (id > 0) {

			let token_keycloack = sessionStorage.getItem('token_keycloack');
			const requestAuthorization = {
				headers: { "Authorization": `Bearer ${token_keycloack}` }
			}

			fetchWithToken(`${URL_API}/api/v1/srf/${id}`, requestAuthorization)
				.then(res => res.json())
				.then(res => {
					if (res === "") {
						this.resultado = "Erro na leitura dos dados de SRF!"
					}
					else {
						setDados(res[0])
					}
				})
				.catch(_err => {
					alert("Erro interno na aplicação.")
					console.error("Erro interno na aplicação - " + _err)
				});
		}
	}, [id])

	function controlarItem(e) {
		setDados(_dados => ({ ...dados, [e.target.name]: e.target.value }))
		return null
	}

	function fecharMensagem() {
		setMostrarMensagem(false)
		return null
	}

	function salvar(_e) {
		if (!dados.codigo.trim().length) {
			alert("O campo código é obrigatório!")
			txtCodigo.current.focus()
			return false
		}
		if (!dados.nome.trim().length) {
			alert("O campo nome é obrigatório!")
			txtNome.current.focus()
			return false
		}
		if (!dados.email.trim().length) {
			alert("O campo email é obrigatório!")
			txtEmail.current.focus()
			return false
		}
		if (!dados.email.match(/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/)) {
			alert("Email inválido!")
			txtEmail.current.focus()
			return false
		}

		let metodo = 'POST'
		let url = `${URL_API}/api/v1/srf/`
		if (id > 0) {
			url = url + dados.codigo
			metodo = 'PUT'
		}
		else{
			url = url + "inserirSrf"
		}

		let token_keycloack = sessionStorage.getItem('token_keycloack');
		const opcoes = {
			method: metodo,
			headers: { 'Content-Type': 'application/json', "Authorization": `Bearer ${token_keycloack}` },
			body: JSON.stringify(dados)
		};
		fetch(url, opcoes)
			.then(res => res.text())
			.then(_res => {
				const retorno = JSON.parse(_res);
				if(retorno.status === 500){
					setMensagem("Ocorreu um erro: "+retorno.trace);
				}else{
					if (id === "0") {
						setMensagem("O registro foi incluído!")
					}
					else {
						setMensagem("O registro foi alterado!")
					}
				}
				setMostrarMensagem(true)
				window.scrollTo(0, 0)
			})
			.catch(_err => {
				alert("Erro interno na aplicação.")
				console.error("Erro interno na aplicação - " + _err)
			});
		return null
	}

	return (
		<div className="container-fluid">
			<div className="row">
				<div className="col-12">
					<Collapse in={mostraMensagem}>
						<Alert action={<IconButton aria-label="close" color="inherit" size="small" focusRipple={mostraMensagem} onClick={ () => fecharMensagem()}><CloseIcon fontSize="inherit" /></IconButton>} sx={{ mb: 2 }}>{mensagem}</Alert>
					</Collapse>
					<header className="main">
						<h2>DISTVAF - Cadastro de SRF</h2>
					</header>
				</div>
			</div>
			<div className="row">
				<div className="col-6">
				</div>
				<div className="col-6">
					<BotaoVoltar />
				</div>
			</div>
			<div className="row">
				<div className="col-12">
					<form>
						<label className="margem-antes">Código</label>
						<input type="text" value={dados.codigo || ''} ref={txtCodigo}  name="codigo" onChange={controlarItem} maxLength="3" />
						<label className="margem-antes">Nome</label>
						<input type="text" value={dados.nome || ''} ref={txtNome} name="nome" onChange={controlarItem} maxLength="40" />
						<label className="margem-antes">Email</label>
						<input type="text" value={dados.email || ''} ref={txtEmail} name="email" onChange={controlarItem} maxLength="45" />
						<label className="margem-antes">Observação</label>
						<textarea name="obs" value={dados.obs || ''} ref={txtObs}  onChange={controlarItem} rows="5" />
						<label className="margem-antes"></label>
						<Button variant="contained" color="primary" onClick={ () => salvar()}>Salvar</Button>
					</form>
				</div>
			</div>
		</div>
	)

}